import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { NavLink, Outlet, Routes,Route } from "react-router-dom";
import UserReport from "../UserReport/UserReport";
import './Report.css';
import { ToastContainer, toast } from "react-toastify";
function Report() {
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch data here
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    const message = localStorage.getItem("userrMessage");
    if (message) {
      toast.success(message);
      localStorage.removeItem("userrMessage"); // Clear after showing
    }
    
     const messageError = localStorage.getItem("usererrorMessage");
    if (messageError) {
      toast.error(messageError);
      localStorage.removeItem("usererrorMessage"); // Clear after showing
    }
  }, []);
  return (
    <div >
      <ToastContainer/>
      {/* Navigation Links */}
      <ul className="nav my-2">
        <li className="nav-item">
          <NavLink
            to="userReport" // Relative path
            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
          >
            Users
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="projectreport" // Relative path
            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
          >
            Projects
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="taskreport" // Relative path
            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
          >
            Tasks
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink
            to="bugreport" // Relative path
            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
          >
            Bugs
          </NavLink>
        </li>
      </ul>

      {/* Container for rendering nested routes */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <Routes>
              <Route path="/" element={<UserReport />} />
            </Routes>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Report;
